import { render, staticRenderFns } from "./DashVideo.vue?vue&type=template&id=2cf75206&"
import script from "./DashVideo.vue?vue&type=script&lang=js&"
export * from "./DashVideo.vue?vue&type=script&lang=js&"
import style0 from "./DashVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports